module.exports = __webpack_public_path__ + "img/ArrowUp-icon.a4556f52.svg";